import React from 'react';

/**
 * Static SVG stand-in for the "Hero Image" block on its palette card: one
 * centered image with rounded corners and nothing else. Wireframe style,
 * matching {@link SubtitlePreviewGraphic}.
 */

const VIEW_W = 1180;
const IMAGE_W = 760;
const IMAGE_H = 300;
const IMAGE_X = (VIEW_W - IMAGE_W) / 2;
const IMAGE_Y = 30;
const VIEW_H = IMAGE_Y + IMAGE_H + 16;

export default function HeroImagePreviewGraphic() {
  return (
    <svg
      viewBox={`0 0 ${VIEW_W} ${VIEW_H}`}
      width="100%"
      role="img"
      aria-label="Hero Image block: a single centered image with no text"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect
        x={IMAGE_X}
        y={IMAGE_Y}
        width={IMAGE_W}
        height={IMAGE_H}
        rx="20"
        fill="#DCE3DF"
        stroke="#C9D3CE"
      />
      <circle cx={IMAGE_X + 170} cy={IMAGE_Y + 95} r="38" fill="#F1F2EF" />
      <path
        d={`M${IMAGE_X + 40} ${IMAGE_Y + IMAGE_H - 30} L${IMAGE_X + 270} ${IMAGE_Y + 140} L${IMAGE_X + 420} ${IMAGE_Y + IMAGE_H - 90} L${IMAGE_X + 540} ${IMAGE_Y + 170} L${IMAGE_X + IMAGE_W - 40} ${IMAGE_Y + IMAGE_H - 30} Z`}
        fill="#20423A"
        opacity="0.55"
      />
    </svg>
  );
}
